import { Link } from 'react-router-dom';

const SeamlessLogo = (props) => {
  return <Link className="logo" to={props.link}>
    <img loading="lazy" src={props.logoSrc} alt={props.logoAltText} title={props.logoTitle} />
  </Link>
};

export default SeamlessLogo;